<template>
    <div
        class="feed-card-extension"
        @click="selectFeed"
    >
        <div v-if="condensed" class="gcmcn-card gcmcn-card-dashboard" >
            <div class="condensed-feed-name">{{source.name}}</div>
        </div>
        <feed-card
            v-else
            class="dashboard-feed-card"
            :feed="source"
            :display-config-button="false"
            :universes="otherPropValue.universes"
            :events="otherPropValue.events"
            :configurations="otherPropValue.configurations"
            :defaultPreviewImageUrl="otherPropValue.defaultPreviewImageUrl"
            :unMutedFeedsUid="otherPropValue.unMutedFeedsUid"
        ></feed-card>
        <i
            v-if="!condensed"
            class="el-icon-arrow-right selection-arrow"
            :class="{'rotate-icon-arrow' : otherPropValue.selectedFeed !== null && otherPropValue.selectedFeed.uid === source.uid}"
        ></i>
        <div class="dashboard-see-more" @click="showFeed">
            <i class="el-icon-view"></i>
            <span>SEE MORE</span>
        </div>
        <div v-if="source.status === 'FAILED'" class="feed-failed">
            <i class="el-icon-warning-outline"></i>
            <span>FEED FAILED</span>
        </div>
    </div>
</template>

<script>

import { FeedCard } from 'gcmcn-common';
export default {

    components: {
        FeedCard,
    },


    props: {
        index: {
            type: Number,
            default: 0
        },
        source: {
            type: Object,
            default () {
                return {};
            }
        },
        otherPropValue: {
            type: Object,
        },
        condensed: {
            type: Boolean,
            default: false
        }
    },

    data (){
        return {

        };
    },

    computed: {

    },

    created (){
    },

    methods: {
        selectFeed (){
            this.$parent.$parent.$emit('select-feed', this.source);
        },
        showFeed (){
            this.$router.push({
                name: 'feeds',
                params: {
                    feedUid: this.source.uid,
                },
            });

        }
    },
};
</script>

<style lang="scss">

    .feed-card-extension{
        position: relative;
        background-color: #222;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        color: #bbb;
        .play-btn {
            border-width: 15px 0 15px 26px !important;

        }
        .pause-btn {
            div {
                height: 30px !important;
                width: 10px !important;
                &+div {
                    margin-left: 5px !important;
                }
            }
        }
        .condensed-feed-name {
            font-weight: bold;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/page/Home/feed-card.vue